import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { AuthGuard } from './core/guards/auth.guard';
import { SettingsContainerComponent } from './group/components/settings-container/settings-container.component';
import { DashboardComponent } from './shared/components/dashboard/dashboard.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { PolicyViewerComponent } from './shared/components/policy-viewer/policy-viewer.component';
import { AcceptInviteComponent } from './user/components/accept-invite/accept-invite.component';
import { LoginComponent } from './user/components/login/login.component';
import { PatientInviteWizardComponent } from './user/components/patient-invite-wizard/patient-invite-wizard.component';
import { RejectInviteComponent } from './user/components/reject-invite/reject-invite.component';
import { ResetPasswordComponent } from './user/components/reset-password/reset-password.component';
import { VerifyEmailComponent } from './user/components/verify-email/verify-email.component';
import { RemoatSignInComponent } from './user/components/remoat-sign-in/remoat-sign-in.component';
import { RelaymdSignInComponent } from './user/components/relaymd-sign-in/relaymd-sign-in.component';
import { VerifyPrescriptionComponent } from './user/components/verify-prescription/verify-prescription.component';
import { VerifyReportComponent } from './user/components/verify-report/verify-report.component';
import { PatientSatisfactionSurveyComponent } from './user/components/patient-satisfaction-survey/patient-satisfaction-survey.component';
import { PatientFormComponent } from './user/components/patient-form/patient-form.component';

export const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    children: [
      /* { path: '', component: HomeComponent, canActivate: [AuthGuard], }, */
      { path: 'settings', component: SettingsContainerComponent, canActivate: [AuthGuard], },
      /* { path: 'history', component: HistoryListComponent },
      { path: 'pending-audio', component: PendingAudioComponent }, */
      // `request/:id` -> `RequestDetailsComponent` was here and is gone with the component
      // (`tasks/pdf-letterhead-placement.md`). It was dead — commented out, referenced by no
      // template — and its name collided with `patient-ai-request-detail`, which is the live
      // AI-request screen and is routed from `patient.module.ts` as `edit-request/:id`.
      { path: 'patients', loadChildren: () => import('./patient/patient.module').then(m => m.PatientModule) },
      // NOTE: `practice/theatre-lists` was removed by §3b of
      // `tasks/theatre-booking-and-procedure-lifecycle.md`. The theatre list is no longer a
      // curated record with its own page — it is a day export over the schedule calendar's
      // procedure appointments, and its inputs live on `PatientAppointment`.
      { path: '', redirectTo: '/patients/schedule', pathMatch: 'full' }
    ]
  },
  { path: 'login', component: LoginComponent },
  { path: 'verify-email/:token', component: VerifyEmailComponent },
  { path: 'remoat/sign-in', component: RemoatSignInComponent },
  { path: 'relaymd/sign-in', component: RelaymdSignInComponent },
  { path: 'verify-prescription/:token', component: VerifyPrescriptionComponent },
  { path: 'verify-report/:exportId', component: VerifyReportComponent },
  { path: 'reset-password/:token', component: ResetPasswordComponent },
  // A new account made for a practice: the same form, worded as choosing a first password.
  { path: 'set-password/:token', component: ResetPasswordComponent, data: { setup: true } },
  { path: 'accept-invite/:token', component: AcceptInviteComponent },
  { path: 'reject-invite/:token', component: RejectInviteComponent },
  { path: 'patient-invite/:token', component: PatientInviteWizardComponent },
  { path: 'patient-satisfaction-survey/:token', component: PatientSatisfactionSurveyComponent },
  // `tasks/patient-forms.md` §5 host 2. OUTSIDE the AuthGuard block above, alongside the invite
  // and survey token pages: the one actor who needs this route is a patient with no account, and
  // §1.2 defect 6 is the dormant build putting exactly this behind auth.
  { path: 'patient-form/:token', component: PatientFormComponent },
  /*
   * `patient-document/:token` USED TO BE HERE and is gone — `tasks/practice-documents.md` §19.
   *
   * Documents ride the `PatientInvite` rail now: the wizard at `patient-invite/:token` above
   * splices one step per outstanding document, and a manual send from the patient file mints a
   * document-only invite rather than a bespoke per-document token (§21.2). Two rails to the same
   * return is what §19 was written to end, so this one is deleted rather than kept as a fallback
   * — a second live path is a second thing to keep correct and a second thing to attack.
   */
  { path: 'policy-viewer', component: PolicyViewerComponent },
  { path: '404', component: PageNotFoundComponent },
  { path: '**', redirectTo: '/404' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    useHash: (environment as any).isNative === true
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }